import { render } from "./UiFilterControls.vue?vue&type=template&id=53310e6d"
import script from "./UiFilterControls.vue?vue&type=script&lang=js"
export * from "./UiFilterControls.vue?vue&type=script&lang=js"

import exportComponent from "D:\\laragon\\www\\leader-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__